var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('soft-table',{ref:"soft-table",staticClass:"table align-items-center table-flush",attrs:{"pending":false,"tbody-classes":"list","fields":_vm.fields,"dataTable":_vm.customerContacts,"norecordAdd":_vm.handleAddNew,"contextMenus":[
      {
        key: 'new',
        icon: 'fa-plus',
        label: 'Thêm mới'
      },
      {
        key: 'copy',
        icon: 'fa-copy',
        label: 'Copy dòng này'
      },
      {
        key: 'edit',
        icon: 'fa-edit',
        label: 'Chỉnh sửa dòng này'
      }
    ]},on:{"rowSelected":_vm.tbSetRowSelected,"rowClicked":_vm.tbRowClicked,"doDeleteRow":_vm.handleDeletes,"doEditRow":_vm.handleEdit,"contextMenuItemClick":_vm.tbHandleContextMenuItemClick},scopedSlots:_vm._u([{key:"cell(name)",fn:function(ref){
    var item = ref.item;
return [_vm._v("\n      "+_vm._s(item.name)+"\n      "),(item.isDefault)?_c('i',{staticClass:"fas fa-star",staticStyle:{"color":"rgb(247, 186, 42)"}}):_vm._e()]}},{key:"cell(type)",fn:function(ref){
    var item = ref.item;
return [(item.type == 'SHIP')?_c('span',{staticClass:"badge badge-pill badge-info"},[_vm._v("\n        Người nhận hàng\n      ")]):(item.type == 'PAYMENT')?_c('span',{staticClass:"badge badge-pill badge-success"},[_vm._v("\n        Người thanh toán\n      ")]):(item.type == 'ORDER')?_c('span',{staticClass:"badge badge-pill badge-primary"},[_vm._v("\n        Người đặt hàng\n      ")]):_c('span',{staticClass:"badge badge-pill badge-danger"},[_vm._v("\n        Không phân loại\n      ")])]}},{key:"cell(action)",fn:function(ref){
    var item = ref.item;
return [_c('button',{staticClass:"btn btn-sm",class:{
          'btn-outline-primary': !item.isDefault,
          'btn-warning': item.isDefault
        },on:{"click":function($event){return _vm.handleSetDefault(item)}}},[_vm._v("\n        Mặc định\n      ")])]}}])}),_c('control-mini',{attrs:{"countChecked":_vm.countChecked},on:{"doAddNew":_vm.handleAddNew,"doEdit":_vm.handleEdit,"search":_vm.handleSearch,"doDelete":_vm.handleDeletes}}),_c('cs-contact-modal',{ref:"cs-contact-modal",on:{"submit:success":function($event){return _vm.$emit('changeData')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }